import { Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { IoIosNotificationsOutline } from "react-icons/io";
import { toast } from "react-toastify";
import useNotificationsAccessHelper from "../../hooks/useNotificationsAccessHelper";
import { showErrors } from "../../utils/ui";
import GModal from "../Modal";
import { IoCheckmark } from "react-icons/io5";
import { StyledSuccessContainer } from "./styles";

const AskNotifications = () => {
  const {
    isNotificationSupported,
    notificationStatus,
    currentDeviceEnrolled,
    setupSubscription,
  } = useNotificationsAccessHelper();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [processing, setIsProcessing] = useState(false);

  const handleAllow = async () => {
    setIsProcessing(true);
    try {
      await setupSubscription();
      toast.success("Notifications enabled");
      setIsModalVisible(false);
    } catch (e) {
      showErrors(e);
    }
    setIsProcessing(false);
  };

  const handleCancel = () => !processing && setIsModalVisible(false);

  return (
    <>
      {!isNotificationSupported ? null : currentDeviceEnrolled &&
        notificationStatus === "granted" ? (
        <StyledSuccessContainer>
          <Typography variant="subtitle2" color="textSecondary">
            Notifications Enabled
          </Typography>
          <IoCheckmark />
        </StyledSuccessContainer>
      ) : (
        <Button
          variant="text"
          color="secondary"
          size="small"
          endIcon={<IoIosNotificationsOutline />}
          onClick={() => setIsModalVisible(true)}
        >
          Enable Notifications
        </Button>
      )}
      <GModal
        title="Enable notifications"
        isOpen={isModalVisible}
        onClose={handleCancel}
        width="540px"
        primaryButton={{
          onClick: handleAllow,
          disabled: processing || notificationStatus === "denied",
          text: "Allow",
        }}
        secondaryButton={{
          onClick: handleCancel,
        }}
      >
        {notificationStatus === "denied" ? (
          <Typography variant="body1">
            Notification permissions are denied, Please update in settings!
          </Typography>
        ) : null}
      </GModal>
    </>
  );
};

export default AskNotifications;
